import getPreviewVhost from './preview-vhost';

export default {
  getPreviewVhost,
};
